<template>
    <div id="Marketing_Video" class="dashboard-card d-flex">
        <CardTemplate>
            <!-- HEADER -->
            <template #header>
                <section class="card-title">
                    <span>Axxess Central</span>
                </section>
            </template>
            <!-- CONTENT -->
            <!-- LOADING -->
            <template #content>
                <section class="video-content">
                    <slot></slot>
                    <div v-if="isError">
                        <ErrorMessageHandler :title="title ? title : 'the data'" v-if="isAuthorized" />
                        <div class="empty-state text-center text-default w-100 p-5" else>
                            <h6 class="fst-italic">
                                You do not have permission to view this data. Contact an administrator at your agency to
                                request access.
                            </h6>
                        </div>
                    </div>
                </section>
            </template>
        </CardTemplate>
    </div>
</template>

<script lang="ts" src="./MarketingVideo.ts"></script>
